import { useState } from 'react';
import useConfig from '@/hooks/useConfig';

export default function ContactForm() {
  let [sending, setSending] = useState(false);
  let [success, setSuccess] = useState(false);
  let [error, setError] = useState('');

  const { t } = useConfig();

  function send(e) {
    e.preventDefault();

    const name = e.target.name.value;
    const email = e.target.email.value;
    const subject = e.target.subject.value;
    const message = e.target.message.value;

    setSending(true);
    setSuccess(false);
    setError('');

    return fetch('/api/contact', {
      method: 'POST',
      body: JSON.stringify({ name, email, subject, message }),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin'
    })
      .then(res => res.json())
      .then(json => {
        if (!json.ok) {
          setError(json.error);
          setSending(false);
          return;
        }

        setSuccess(true);
        setSending(false);
      })
      .catch(() => {
        setError('Internal Server Error');
        setSending(false);
      });
  }

  return (
    <form autoComplete="off" onSubmit={send}>
      <div className="input-group">
        <label htmlFor="name">{t('contact.labels.name')}:</label>
        <input name="name" id="name" required />
      </div>
      <div className="input-group">
        <label htmlFor="email">{t('contact.labels.email')}:</label>
        <input type="email" name="email" id="email" required />
      </div>
      <div className="input-group">
        <label htmlFor="subject">{t('contact.labels.subject')}:</label>
        <input name="subject" id="subject" />
      </div>
      <div className="input-group">
        <label htmlFor="message">{t('contact.labels.message')}:</label>
        <textarea name="message" id="message"></textarea>
      </div>

      {success && (<div className="messagebox success">{t('contact.messages.success')}</div>)}
      {error && error.length && (<div className="messagebox error">{error}</div>)}
      {sending && (<div className="messagebox info">{t('contact.messages.sending')}</div>)}

      <div className="input-group buttons">
        <button type="submit" disabled={sending}>
          {t('contact.buttons.send')}
        </button>
      </div>
    </form>
  );
}
